import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const documentUsersService = { Get, Edit, getFileAccess, updateFileAccess, getDocumentUserAccess };

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'DocumentUsers'
};

function extract(r) {
  return r.data;
}

async function Get(documentVersionCode) {
  return axios.get(`${model.baseUrl}${model.controller}/Get?documentVersionCode=${documentVersionCode}`).then(extract);
}

async function Edit(documentUsersId, documentUserTypeId) {
  return axios.post(`${model.baseUrl}${model.controller}/Edit`, { documentUsersId, documentUserTypeId });
}

async function getFileAccess(documentVersionCode, documentUsersId) {
  return axios
    .get(`${model.baseUrl}${model.controller}/GetFilesAccess?documentVersionCode=${documentVersionCode}&documentUsersId=${documentUsersId}`)
    .then(extract);
}

async function updateFileAccess(documentVersionCode, documentUsersId, readFiles, writeFiles, isHideOtherContragents, isDelayAccess, delayAccessDate, isSendToAcqu, isSendToAgree, isSendToSign) {
  return axios.put(`${model.baseUrl}${model.controller}/UpdateFilesAccess`, { documentVersionCode, documentUsersId, readFiles, writeFiles, isHideOtherContragents, isDelayAccess, delayAccessDate, isSendToAcqu, isSendToAgree, isSendToSign });
}

async function getDocumentUserAccess(documentVersionCode: string) {
  return axios
    .get(`${model.baseUrl}${model.controller}/GetDocumentUserAccess?documentVersionCode=${documentVersionCode}`)
    .then(extract);
}
